import { NumberField, SelectField } from '@flos/react-ui';
import { useHippoText } from '../../../hooks/useHippoText';
import type { EDICancellationReason_Top } from 'gw-edge-client/dist/types/dto/pc/typekey';
import { useState } from 'react';
import {
    CancellationReason,
    updateExternalCaseDTOProperties
} from '../../../utils/externalCasesUtil';
import type { ExternaleCaseDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/policyjob/edi/dto';
import { useRecoilState } from 'recoil';
import { externalCasesAtom } from '../../../recoil/atoms/externalCasesAtom';

const PrhEdiCancellationReason = ({
    externalCase
}: {
    externalCase: ExternaleCaseDTO;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const { caseId, cancellationReason, currentPolicyNumber } = externalCase;
    const [prhCancellationReason, setPrhCancellationReason] = useState<string>(
        cancellationReason === CancellationReason.ChangeOfOwnership
            ? CancellationReason.ChangeOfOwnership
            : CancellationReason.ShortRate
    );
    const [externalCaseDTOList, setExternalCaseDTOList] = useRecoilState(externalCasesAtom);

    if (!caseId) return <></>;

    const handleCancellationReasonChange = (value: string): void => {
        setPrhCancellationReason(value);
        const updateValue: ExternaleCaseDTO = {
            cancellationReason: value as EDICancellationReason_Top,
            cancellationOnExpirationDate: false,
            insuredIsAccountHolder: true
        };
        const updatedExternalCaseProperties = updateExternalCaseDTOProperties(
            externalCaseDTOList,
            [caseId],
            updateValue
        );
        setExternalCaseDTOList(updatedExternalCaseProperties);
    };

    const handlePolicyNumberChange = (value: string): void => {
        const updateValue: ExternaleCaseDTO = {
            currentPolicyNumber: value
        };
        const updatedExternalCaseProperties = updateExternalCaseDTOProperties(
            externalCaseDTOList,
            [caseId],
            updateValue
        );
        setExternalCaseDTOList(updatedExternalCaseProperties);
    };
    return (
        <>
            <SelectField
                label={getHippoText('DSS-EFFECTIVE-DATE-AND-CANCELLATION-POLICY-REASONLABEL')}
                id={`prh-cancellation-reason-${caseId}`}
                onChange={(event) => {
                    handleCancellationReasonChange(event.target.value);
                }}
                value={prhCancellationReason}
                options={[
                    {
                        label: getHippoText('DSS-EFFECTIVE-DATE-AND-CANCELLATION-POLICY-REASON1'),
                        value: CancellationReason.ChangeOfOwnership
                    },
                    {
                        label: getHippoText('DSS-EFFECTIVE-DATE-AND-CANCELLATION-POLICY-REASON2'),
                        value: CancellationReason.ShortRate
                    }
                ]}
                placeholder={getHippoText('DSS-EFFECTIVE-DATE-AND-CANCELLATION-POLICY-REASONLABEL')}
            />
            {cancellationReason === CancellationReason.ChangeOfOwnership && (
                <NumberField
                    label={getHippoText('DSS-EFFECTIVE-DATE-AND-CANCELLATION-POLICY-NUMBER')}
                    id={`policy-nr-${caseId}`}
                    value={currentPolicyNumber}
                    onChange={(event) => {
                        handlePolicyNumberChange(event.target.value);
                    }}
                />
            )}
        </>
    );
};

export default PrhEdiCancellationReason;
